import React from 'react';
import { observer } from 'mobx-react';
import { Field, FieldInputProps, FieldRenderProps } from 'react-final-form';

import AppStorage from 'Storage/Storage';
import { translate } from 'utils/utils';
import Labels from '../../enums/Labels';
import { TafSelectInput } from '@taf-ui/react';
import { TafChangeEvent } from '@taf-ui/core';

type Props = {
  onBlurHandler?: (e: CustomEvent<TafChangeEvent<string>>) => void;
};

class InputGender extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  constructor(props: {}) {
    super(props);

    this.storage = AppStorage.getInstance();
  }

  handleChange = (e: CustomEvent<TafChangeEvent<string>>, input: FieldInputProps<string>) => {
    input.onChange(e.detail.value);
    const {
      onBlurHandler,
    } = this.props;
    if (onBlurHandler) {
      onBlurHandler(e);
    }
  };

  render(): React.ReactElement {

    const options = [
      { value: 'MALE', title: translate(Labels.PERSONAL_DETAILS_MALE, this.storage.getLocale) },
      { value: 'FEMALE', title: translate(Labels.PERSONAL_DETAILS_FEMALE, this.storage.getLocale) },
    ];

    return (
      <Field name="gender">
        {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
          <TafSelectInput
            label={translate(Labels.PERSONAL_DETAILS_GENDER, this.storage.getLocale)}
            value={input.value}
            name="gender"
            inputId="gender"
            onTafChange={(e) => this.handleChange(e, input)}
            onTafBlur={() => input.onBlur()}
            validationState={meta.error && meta.touched ? 'error' : undefined}
            validationMessage={translate(meta.error as Labels, this.storage.getLocale)}
            options={options}
            required={true}
          />
        )}
      </Field>
    );
  }
}

export default observer(InputGender);
